<template>
    <div class="home">
        <estimates />
    </div>
</template>

<script>
    import Estimates from "../components/views/Estimates.vue"
    export default {
        name: "EstimatesView",
        components: {Estimates}
    }
</script>

<style scoped>

</style>
